import React, { createContext, useContext, useState, useCallback, memo } from 'react';
import { useMediaQuery } from '@mui/material';

interface DrawerContextType {
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  isMobile: boolean;
  drawerWidth: number;
  collapsedDrawerWidth: number;
  getContentMarginLeft: () => number;
  showAllGroups: boolean;
  setShowAllGroups: React.Dispatch<React.SetStateAction<boolean>>;
  isGroupSelected: boolean;
  setIsGroupSelected: React.Dispatch<React.SetStateAction<boolean>>;
  fundManagementAdminRight: boolean;
  setFundManagementAdminRight: React.Dispatch<React.SetStateAction<boolean>>;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const useDrawer = (): DrawerContextType => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};

interface DrawerProviderProps {
  children: React.ReactNode;
}

export const DrawerProvider: React.FC<DrawerProviderProps> = memo(({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showAllGroups, setShowAllGroups] = useState(true);
  const [isGroupSelected, setIsGroupSelected] = useState(false);
  const [fundManagementAdminRight, setFundManagementAdminRight] = useState(false);

  const isMobile = useMediaQuery('(max-width: 900px)');
  const drawerWidth = 280;
  const collapsedDrawerWidth = 70;

  const getContentMarginLeft = useCallback(() => {
    if (isMobile) return 0;
    return drawerOpen ? drawerWidth : collapsedDrawerWidth;
  }, [isMobile, drawerOpen]);

  const contextValue = {
    drawerOpen,
    setDrawerOpen,
    isMobile,
    drawerWidth,
    collapsedDrawerWidth,
    getContentMarginLeft,
    showAllGroups,
    setShowAllGroups,
    isGroupSelected,
    setIsGroupSelected,
    fundManagementAdminRight,
    setFundManagementAdminRight
  };

  console.log('DrawerContext fundManagementAdminRight', fundManagementAdminRight);

  return <DrawerContext.Provider value={contextValue}>{children}</DrawerContext.Provider>;
});

DrawerProvider.displayName = 'DrawerProvider';
